import React from 'react';
export function Footer() {
  return <footer className="bg-navy-900 px-5 pb-32 pt-10 text-white/60" data-id="element-159" data-mp="19ivlq3plplne">
      <div className="mx-auto max-w-3xl text-center" data-id="element-160" data-mp="206j2vgr4o7dc">
        <p className="text-xs font-extrabold uppercase tracking-[0.14em] text-white/80" data-id="element-161" data-mp="209x42lo22aj7">Professional Disclaimer</p>
        <div className="mt-3 space-y-3 text-xs leading-relaxed" data-id="element-162" data-mp="2a607rvyk2h89">
          <p data-id="element-163" data-mp="2a6iexnmrafuy">
            Postoperative Wound Complications Blueprint™ is an educational and professional workflow-support resource
            intended for qualified healthcare practitioners.
          </p>
          <p data-id="element-164" data-mp="1heypvn3ha7l1">
            It does not provide patient-specific medical advice, establish independent treatment protocols, replace
            clinical judgment, or supersede institutional policies.
          </p>
          <p data-id="element-165" data-mp="13pohsi5w05nr">
            Potentially urgent findings require assessment and escalation in accordance with applicable clinical
            protocols and professional responsibilities.
          </p>
        </div>
        <p className="mt-6 text-xs" data-id="element-166" data-mp="1eic0z0u0a6nj">© 2026 Postoperative Wound Complications Blueprint™. All rights reserved.</p>
      </div>
    </footer>;
}